import { envConfig } from "@configs/env";
import { DeployCountry } from "@types";
import { cn } from "kz-ui-sdk";
import { PropsWithChildren, ReactNode, useMemo } from "react";
import { FaTelegramPlane } from "react-icons/fa";
import { SiLine } from "react-icons/si";

interface ContactButtonProps extends PropsWithChildren {
  url: string;
  className?: string;
}

const ContactButton = ({ url, className }: ContactButtonProps) => {
  const buttonStyle = useMemo(() => {
    // hardcode first in sprint 3
    return BUTTON_COUNTRY_STYLES[envConfig.countryCode];
  }, []);

  return (
    <a
      href={url}
      className={cn(
        buttonStyle.className,
        className,
        "flex h-[30px] w-[38px] items-center justify-center rounded px-1.5",
      )}
      target={"_blank"}
      rel={"noreferrer noopener"}
    >
      {buttonStyle.icon}
    </a>
  );
};

type ContactButtonStyle = {
  icon: ReactNode;
  className: string;
  urlRegex?: RegExp;
};

const BUTTON_STYLES: Record<string, ContactButtonStyle> = {
  telegram: {
    icon: (
      <FaTelegramPlane
        color="currentColor"
        className="text-white"
        size={16}
      />
    ),
    className: "bg-[linear-gradient(180deg,#35AEE1_0%,#2096D4_100%)]",
    urlRegex: /t\.me/,
  },
  line: {
    icon: (
      <SiLine
        color="currentColor"
        className="text-white"
        size={24}
      />
    ),
    className: "bg-[radial-gradient(50%_100%_at_50%_0%,_#06C755_0%,_#06C755_100%)]",
    urlRegex: /line\.me/,
  },
  liveChat: {
    icon: (
      <img
        src="/images/icon-livechat.png"
        className="h-6 w-auto"
      />
    ),
    className: "!p-1.5 h-[30px] w-[38px] bg-white",
    urlRegex: /livechat\.com/,
  },
  general: {
    icon: (
      <img
        src="/images/icon-chat-general.png"
        className="h-[30px] w-auto object-contain"
      />
    ),
    className: "flex flex-col items-center justify-center !pr-0 -mr-2",
    urlRegex: /livechat\.com/,
  },
};

const BUTTON_COUNTRY_STYLES: Record<DeployCountry, ContactButtonStyle> = {
  [DeployCountry.PH]: BUTTON_STYLES["general"],
  [DeployCountry.TH]: BUTTON_STYLES["line"],
};

export default ContactButton;
